import { render, staticRenderFns } from "./cargoContactsInfoDialog.vue?vue&type=template&id=0bdf2e40&"
import script from "./cargoContactsInfoDialog.vue?vue&type=script&lang=js&"
export * from "./cargoContactsInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdf2e40')) {
      api.createRecord('0bdf2e40', component.options)
    } else {
      api.reload('0bdf2e40', component.options)
    }
    module.hot.accept("./cargoContactsInfoDialog.vue?vue&type=template&id=0bdf2e40&", function () {
      api.rerender('0bdf2e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/cargoContactsInfoDialog.vue"
export default component.exports